import * as React from 'react';
import { isNumber, isValidPhoneNumberInput } from '@/utils/utils';
import { useState } from 'react';
import TextInput from '../../../../../packages/components/src/textInput/TextInput';

type Props = {
  id: string;
  name: string;
  label?: string;
  placeholder: string;
  addHyphen?: boolean;
  onChange?: (value: string) => void;
  classes?: string;
};

const PhonenumberInput = ({ id, name, label, placeholder, onChange, addHyphen = false, classes = '' }: Props) => {
  const [inputValue, setInputValue] = useState<string>('');

  const handleChange = (value: string) => {
    let valueResult = value;
    if (isValidPhoneNumberInput(value) && addHyphen) {
      if (valueResult.length === 3 && !inputValue.includes('-')) {
        // Add hyphen after the 3rd digit if it's not already there
        valueResult = inputValue.slice(0, 3) + '-' + inputValue.slice(3);
      } else if (inputValue.length === 4 && inputValue.includes('-')) {
        // Remove the hyphen if the length becomes 4 and there is a hyphen
        valueResult = inputValue.slice(0, 3) + inputValue.slice(4);
      }
      setInputValue(valueResult);
      onChange && onChange(valueResult);
    } else if (isNumber(value) && !addHyphen) {
      setInputValue(valueResult);
      onChange && onChange(valueResult);
    } else {
      onChange && onChange(inputValue);
    }
  };

  return (
    <TextInput
      id={id}
      name={name}
      label={label}
      placeholder={placeholder}
      type="tel"
      className={classes}
      onChange={handleChange}
      value={inputValue}
    />
  );
};
export default PhonenumberInput;
